class QuicklinksController {
	static SELECTOR_CLASS_BLOCK = '.wp-block-jtf-jtf-quicklinks'
	static SELECTOR_CLASS_JTF_BLOCK = '.jtf__block'
	static SELECTOR_CLASS_RETURNTOTOP = '.returntotop__container'
	static CLASS_NAME_QUICKLINKSBLOCK = 'jtf__quicklinksblock'
	static CLASS_NAME_TITLE = 'jtf__quicklinksblock--title'
	static CLASS_NAME_LINKS = 'jtf__quicklinksblock--links'
	static CLASS_NAME_LINKS_OPEN = 'jtf__quicklinksblock--links-open'
	static CLASS_NAME_TITLE_OPEN = 'jtf__quicklinksblock--title-open'
	static CLASS_NAME_LOCKED = 'jtf__quicklinksblock--locked'
	static CLASS_NAME_INFOCUS = 'jtf__quicklinksblock--infocus'
	static SELECTOR_ANCHOR_HASH = 'a[href*=\\#]'
	static SELECTOR_BUTTON = 'button'
	static ATTR_ID = 'id'
	static ATTR_DATA_COPY = 'data-copy'
	static ATTR_ARIA_EXPANDED = 'aria-expanded'
	static ATTR_DISABLED = 'disabled'
	static ATTR_TABINDEX = 'tabindex'
	static PROP_TRUE = 'true'
	static PROP_FALSE = 'false'
	static SCROLL_OFFSET = 150
	static ANIMATION_DURATION = 500

	constructor() {
		this.blockClass = document.querySelector( QuicklinksController.SELECTOR_CLASS_BLOCK )
		this.blockTitle = document.querySelector( '.' + QuicklinksController.CLASS_NAME_TITLE )
		this.blockLinks = document.querySelector( '.' + QuicklinksController.CLASS_NAME_LINKS )

		if ( this.blockClass && this.blockTitle && this.blockLinks ) {
			this.init()
		}
	}

	resetWidth() {
	}

	init() {
		this.resetWidth()
		this.populateQuicklinks()
		this.initQuicklinkClicks()
		this.initScrollHandler()
		this.initTitleClickHandler()
		this.initResizeHandler()
	}

	populateQuicklinks() {
		const blocks = document.querySelectorAll( QuicklinksController.SELECTOR_CLASS_JTF_BLOCK )
		for ( const block of blocks ) {
			const targetId = block.getAttribute( QuicklinksController.ATTR_ID )
			const targetCopy = block.getAttribute( QuicklinksController.ATTR_DATA_COPY )

			if ( targetId && targetCopy ) {
				const li = document.createElement( 'li' )
				const a = document.createElement( 'a' )
				a.href = '#' + targetId
				a.textContent = targetCopy
				li.appendChild( a )
				this.blockLinks.appendChild( li )
			}
		}
	}

	initQuicklinkClicks() {
		const links = this.blockLinks.querySelectorAll( QuicklinksController.SELECTOR_ANCHOR_HASH )
		for ( const link of links ) {
			if ( !link.classList.contains( QuicklinksController.SELECTOR_CLASS_RETURNTOTOP.substring( 1 ) ) ) {
				link.addEventListener( 'click', ( e ) => {
					e.preventDefault()
					this.blockLinks.classList.remove( QuicklinksController.CLASS_NAME_LINKS_OPEN )
					this.blockTitle.classList.remove( QuicklinksController.CLASS_NAME_TITLE_OPEN )
					const button = this.blockTitle.querySelector( QuicklinksController.SELECTOR_BUTTON )
					if ( button ) {
						button.setAttribute( QuicklinksController.ATTR_ARIA_EXPANDED, QuicklinksController.PROP_FALSE )
					}

					const targetElement = document.querySelector( link.hash )
					if ( targetElement ) {
						this.smoothScrollTo( targetElement )
					}
				} )
			}
		}
	}

	smoothScrollTo( targetElement ) {
		const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - QuicklinksController.SCROLL_OFFSET
		const startPosition = window.scrollY
		const distance = targetPosition - startPosition
		const duration = QuicklinksController.ANIMATION_DURATION
		let start = null

		const step = ( timestamp ) => {
			if ( !start ) {
				start = timestamp
			}
			const progress = timestamp - start
			const percentage = Math.min( progress / duration, 1 )
			const easing = percentage * (2 - percentage)
			window.scrollTo( 0, startPosition + distance * easing )

			if ( progress < duration ) {
				window.requestAnimationFrame( step )
			} else {
				if ( !targetElement.hasAttribute( QuicklinksController.ATTR_TABINDEX ) ) {
					targetElement.setAttribute( QuicklinksController.ATTR_TABINDEX, '-1' )
				}
				targetElement.focus()
			}
		}

		window.requestAnimationFrame( step )
	}

	initScrollHandler() {
		document.addEventListener( 'scroll', () => {
			const topOfParent = this.blockClass.getBoundingClientRect().top + window.scrollY
			const currentScrollPosition = window.scrollY
			const blocks = document.querySelectorAll( '.' + QuicklinksController.CLASS_NAME_QUICKLINKSBLOCK )

			for ( const block of blocks ) {
				const targetId = block.getAttribute( QuicklinksController.ATTR_ID )
				if ( targetId ) {
					const offset = block.getBoundingClientRect().top + window.scrollY
					const blockHeight = block.offsetHeight
					const link = document.querySelector( '[href="#' + targetId + '"]' )

					if ( link ) {
						if ( offset <= currentScrollPosition && currentScrollPosition <= offset + blockHeight ) {
							link.classList.add( QuicklinksController.CLASS_NAME_INFOCUS )
						} else {
							link.classList.remove( QuicklinksController.CLASS_NAME_INFOCUS )
						}
					}
				}
			}

			const button = this.blockTitle.querySelector( QuicklinksController.SELECTOR_BUTTON )
			if ( currentScrollPosition >= topOfParent ) {
				this.blockClass.classList.add( QuicklinksController.CLASS_NAME_LOCKED )
				if ( button ) {
					button.removeAttribute( QuicklinksController.ATTR_DISABLED )
				}
				this.resetWidth()
			} else {
				this.blockClass.classList.remove( QuicklinksController.CLASS_NAME_LOCKED )
				if ( button ) {
					button.setAttribute( QuicklinksController.ATTR_DISABLED, QuicklinksController.PROP_TRUE )
				}
				this.resetWidth()
			}
		} )
	}

	initTitleClickHandler() {
		this.blockTitle.addEventListener( 'click', () => {
			const button = this.blockTitle.querySelector( QuicklinksController.SELECTOR_BUTTON )
			const isTitleOpen = this.blockTitle.classList.contains( QuicklinksController.CLASS_NAME_TITLE_OPEN )

			if ( button ) {
				if ( isTitleOpen ) {
					button.setAttribute( QuicklinksController.ATTR_ARIA_EXPANDED, QuicklinksController.PROP_FALSE )
				} else {
					button.setAttribute( QuicklinksController.ATTR_ARIA_EXPANDED, QuicklinksController.PROP_TRUE )
				}
			}
			this.blockLinks.classList.toggle( QuicklinksController.CLASS_NAME_LINKS_OPEN )
			this.blockTitle.classList.toggle( QuicklinksController.CLASS_NAME_TITLE_OPEN )
		} )
	}

	initResizeHandler() {
		window.addEventListener( 'resize', () => {
			this.resetWidth()
		} )
	}
}

document.addEventListener( 'DOMContentLoaded', () => {
	if ( document.querySelector( QuicklinksController.SELECTOR_CLASS_BLOCK ) ) {
		new QuicklinksController()
	}
} )
